module.exports = __webpack_public_path__ + "img/04_no.f339dfa8.svg";